"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeGaurd = void 0;
var effects_1 = require("redux-saga/effects");
var takeGaurd = function (type) {
    return (0, effects_1.take)(type);
};
exports.takeGaurd = takeGaurd;
